/* Mobile Menu */

document.addEventListener('DOMContentLoaded', function () {
  // 1. On load, check if script#MobileContent exists and save its content
  let mobileContent = null;
  const mobileContentScript = document.querySelector('script#MobileContent');
  if (mobileContentScript) {
    mobileContent = mobileContentScript.innerHTML;
  }

  // 2. Check if #mobile-menu exists and save it
  const mobileMenuEl = document.getElementById('mobile-menu');

  // 3. If both exist, inject the HTML content
  if (mobileContent && mobileMenuEl) {
    mobileMenuEl.querySelector('[data-content]').innerHTML = mobileContent;
  }

  // Toggle submenu function
  function setupSubmenuToggles() {
    document.querySelectorAll('button[data-toggle-submenu]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const submenu = btn.nextElementSibling;
        if (submenu && submenu.tagName === 'UL') {
          submenu.style.display = submenu.style.display === 'block' ? 'none' : 'block';
        }
      });
    });
  }

  // Call on initial load and after injecting content
  setupSubmenuToggles();

  const mobMenuOpenEl = document.querySelector('.mobile-menu-toggle');
  const mobMenuCloseEl = mobileMenuEl.querySelector('.mm-close');
  const mobMenuOverlayEl = document.querySelector('.mm-overlay');
  const mobSearchEl = document.querySelector('.header-v2__search-form');
  const mobSearchOpenEl = document.querySelector('.mobile-search-open');
  const mobSearchCloseEl = document.querySelector('.mobile-search-close');

  // Add click event to show mobile menu and overlay
  if (mobMenuOpenEl && mobileMenuEl && mobMenuOverlayEl) {
    mobMenuOpenEl.addEventListener('click', function () {
      mobileMenuEl.style.display = 'block';
      mobMenuOverlayEl.style.display = 'block';
    });
  }

  // Add click event to close mobile menu and overlay
  if (mobMenuCloseEl && mobileMenuEl && mobMenuOverlayEl) {
    mobMenuCloseEl.addEventListener('click', function () {
      mobileMenuEl.style.display = '';
      mobMenuOverlayEl.style.display = '';
    });
  }

  // Add click event to show mobile search and overlay
  if (mobSearchOpenEl && mobSearchEl && mobMenuOverlayEl) {
    mobSearchOpenEl.addEventListener('click', function () {
      mobSearchEl.classList.add('mobile-search-form');
      mobMenuOverlayEl.style.display = 'block';
      mobMenuOverlayEl.style.zIndex = '99';
    });
  }

  // Add click event to close mobile search and overlay
  if (mobSearchCloseEl && mobSearchEl && mobMenuOverlayEl) {
    mobSearchCloseEl.addEventListener('click', function () {
      mobSearchEl.classList.remove('mobile-search-form');
      mobMenuOverlayEl.style.display = '';
      mobMenuOverlayEl.style.zIndex = '';
    });
  }

  // Select all top-level list items in the navigation
  const navItems = document.querySelectorAll('.header-v2__lvl-1-parent');

  function removeHoverClass() {
    const currentHover = document.querySelector('.header-v2__lvl-1-parent.hover');
    if (currentHover) {
      currentHover.classList.remove('hover');
    }
  }

  navItems.forEach((item) => {
    item.addEventListener('mouseenter', function () {
      removeHoverClass();
      this.classList.add('hover');
    });
  });
});
